import { supabase } from '../../supabaseClient';

export function fetchBrickTimesheets(allIds) {
  return supabase
    .from('timesheets')
    .select('brique_id,dev_id,heures,date')
    .in('brique_id', allIds)
    .order('id');
}

export function fetchMonthTimesheets(firstDay, lastDay, userId) {
  return supabase
    .from('timesheets')
    .select('*')
    .eq('user_id', userId)
    .gte('date', firstDay)
    .lte('date', lastDay);
}

export function fetchDayTimesheets(date, session) {
  return supabase
    .from('timesheets')
    .select('id,brique_id,heures,source')
    .eq('user_id', session.user.id)
    .eq('date', date);
}

export function fetchYearTimesheets(exportYear, userId) {
  return supabase
    .from('timesheets')
    .select('date,brique_id,heures')
    .eq('user_id', userId)
    .gte('date', `${exportYear}-01-01`)
    .lte('date', `${exportYear}-12-31`);
}

export function countTimesheetsByBricks(phBriqueIds) {
  return supabase
    .from('timesheets')
    .select('id', { count: 'exact', head: true })
    .in('brique_id', phBriqueIds);
}

export function countTimesheetsByBrick(b) {
  return supabase
    .from('timesheets')
    .select('id', { count: 'exact', head: true })
    .eq('brique_id', b.id);
}

export function countClientTimesheets(allAffBriqueIds) {
  return supabase
    .from('timesheets')
    .select('id', { count: 'exact', head: true })
    .in('brique_id', allAffBriqueIds);
}
